export default __webpack_public_path__ + "static/media/solar-roof.acfd9045.jpg";